module.exports = __webpack_public_path__ + "img/icon-activity-demo-active.86c657aa.svg";